
import { defineComponent } from "vue";

export default defineComponent({
  name: "FlowSwapButton",
  emits: ["click"]
});
